import { motion } from "framer-motion";
import { MessageSquare, CalendarSearch, CheckCircle2, BellRing, RefreshCw } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const steps = [
    {
        icon: MessageSquare,
        title: "Cliente faz contato",
        text: "Manda mensagem no WhatsApp ou liga no número do negócio.",
    },
    {
        icon: CalendarSearch,
        title: "O agente entende e consulta a agenda",
        text: "Interpreta o pedido e verifica a disponibilidade em tempo real.",
    },
    {
        icon: CheckCircle2,
        title: "Propõe horários e confirma",
        text: "Oferece as opções livres e fecha o agendamento na hora.",
    },
    {
        icon: BellRing,
        title: "Confirma e notifica você",
        text: "Envia a confirmação pro cliente e avisa o profissional.",
    },
    {
        icon: RefreshCw,
        title: "Lembra e remarca",
        text: "Lembra 24h antes e 1h antes (ou como preferir) — personalizável com o seu negócio, e remarca se necessário.",
    },
];

export const Journey = () => {
    return (
        <section id="como-funciona" className="relative py-24 md:py-32 lg:py-40">
            <div className="max-w-6xl mx-auto px-6 md:px-12">
                <Reveal>
                    <p className="text-sm md:text-base font-semibold uppercase tracking-widest text-[#94B4FF]">
                        Como funciona
                    </p>
                    <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#F5F5F5] max-w-3xl">
                        Do primeiro contato ao cliente na cadeira
                    </h2>
                </Reveal>

                <div className="relative mt-16">
                    {/* vertical glowing line */}
                    <div className="absolute left-[27px] md:left-1/2 top-2 bottom-2 w-px md:-translate-x-1/2 bg-[#1E1E28]" />
                    <motion.div
                        initial={{ scaleY: 0 }}
                        whileInView={{ scaleY: 1 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 1.4, ease: "easeOut" }}
                        style={{ transformOrigin: "top" }}
                        className="absolute left-[27px] md:left-1/2 top-2 bottom-2 w-px md:-translate-x-1/2 bg-gradient-to-b from-[#3B6FFF] via-[#3B6FFF] to-transparent shadow-[0_0_12px_rgba(59,111,255,0.6)]"
                    />

                    <div className="space-y-8">
                        {steps.map((s, i) => (
                            <Reveal key={s.title} delay={i * 0.08}>
                                <div
                                    data-testid={`journey-step-${i}`}
                                    className={`relative flex items-start gap-6 md:w-1/2 ${
                                        i % 2 === 1
                                            ? "md:ml-auto md:pl-12"
                                            : "md:pr-12 md:flex-row-reverse md:text-right"
                                    }`}
                                >
                                    <div className="relative z-10 flex-shrink-0">
                                        <div className="flex h-14 w-14 items-center justify-center rounded-full border border-[#3B6FFF]/40 bg-[#0A0A0F] text-[#3B6FFF] shadow-[0_0_20px_rgba(59,111,255,0.25)]">
                                            <s.icon className="w-6 h-6" />
                                        </div>
                                    </div>
                                    <div className="rounded-2xl border border-[#1E1E28] bg-[#121218] p-6 flex-1">
                                        <div className="text-xs font-semibold text-[#94B4FF]">
                                            Etapa {i + 1}
                                        </div>
                                        <h3 className="mt-1 font-display text-lg font-semibold text-[#F5F5F5]">
                                            {s.title}
                                        </h3>
                                        <p className="mt-2 text-[#F5F5F5]/60">{s.text}</p>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>

                <Reveal delay={0.1}>
                    <p className="mt-16 text-center font-display text-xl md:text-2xl font-semibold text-[#F5F5F5]">
                        Tudo isso acontece enquanto você{" "}
                        <span className="text-[#3B6FFF]">trabalha, dorme</span> ou está em
                        atendimento.
                    </p>
                </Reveal>
            </div>
        </section>
    );
};

export default Journey;
